<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name: "MarkProducts",
  components: {NavbarPage, LoadingPage},
  setup() {

    let loading = ref(false)

    let products = ref([])
    let advers = ref([])
    let executives = ref([])
    let eductions = ref([])
    let store = ref([])

    let page = ref('prod')

    function load_mark() {
      loading.value = true
      FreeWorld.Heisenberg({}, 'marks', true).then((result) => {

        loading.value = false
        let res = result.data
        products.value = res.products
        advers.value = res.adver
        executives.value = res.executives
        store.value = res.store
        eductions.value = res.education

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, load_mark)
      })
    }
    load_mark()

    return {

      page,
      products,
      advers,
      executives,
      eductions,
      store,
      loading,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div dir="ltr" id="main" :class="loading ? 'activeClass' : '' " class="bg-main">

    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">
          نشان شده ها
        </p>
        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="list_saver p-body mt-2">

      <v-btn @click="page = 'prod' " :class="page == 'prod' ? 'bg-color' : 'bg-unavailable' "
             class="title_saver p-2 h-100  font-5 rounded-3 border-costom text-white mx-2">
        محصولات نشان شده
      </v-btn>

      <v-btn @click="page = 'adver' " :class="page == 'adver' ? 'bg-color' : 'bg-unavailable' "
             class="title_saver p-2 h-100 font-5 rounded-3 border-costom text-white mx-2">
        آگهی نشان شده
      </v-btn>

      <v-btn @click="page = 'executive' " :class="page == 'executive' ? 'bg-color' : 'bg-unavailable' "
             class="title_saver p-2 h-100 font-5 rounded-3 border-costom text-white mx-2">
        مجری نشان شده
      </v-btn>

      <v-btn @click="page = 'education' " :class="page == 'education' ? 'bg-color' : 'bg-unavailable' "
             class="title_saver p-2 h-100 font-5 rounded-3 border-costom text-white mx-2">
        آموزش نشان شده
      </v-btn>

      <v-btn @click="page = 'store' " :class="page == 'store' ? 'bg-color' : 'bg-unavailable' "
             class="title_saver p-2 h-100 font-5 rounded-3 border-costom text-white mx-2">
        فروشگاه نشان شده
      </v-btn>

    </div>

    <br>

    <div v-if="page == 'prod'" class="list_products p-body">
      <!--      ***  محصول   *** -->

      <div v-if="products.length == 0"
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
          <br>
          <p class="font-5 ">
            محصول نشان شده ای وجود ندارد
          </p>
        </div>
      </div>

      <router-link v-else v-for="item in products" :key="item.id"
                   :to="{name:'DetailsProducts' , params:{prod_id:item.id , sub_cat_id:item.sub_categoris}}"
                   class="products_custom animate__animated animate__fadeIn rounded-shaped text-decoration-none text-black d-flex flex-row-reverse justify-content-between mb-2 shadow-costom p-body">

        <div class="position-relative">

          <div style="height: 11rem;width: 11rem" class="animated-background rounded-4">
            <img v-if="item.pic1 == null " class="w-100 h-100 rounded-4" src="../assets/img/img-notavalible.jpg" alt="">
            <img v-else style="object-fit: cover" class="w-100 h-100 rounded-4" :src="item.pic1" alt="">
          </div>


          <div class="div_stars rounded-pill d-flex position-absolute shadow-costom align-items-center">
            <img style="width: 20px" src="../assets/img/star_gold.svg" alt="">

            <p class="m-0 font-5 mx-1 text-center">{{ item.rating_product }}</p>
          </div>

        </div>

        <div style="width: calc(100% - 11.5rem)" class="information_products">

          <p class="m-0 font-5 font-bold ">{{ item.name }}</p>
          <div class="d-flex justify-content-start align-items-center my-1">
            <div class="d-flex">
              <img style="width: 15px" src="../assets/img/shop.svg" alt="">
              <p class="m-0 font-5 mx-2">{{ item.store_name }}</p>
            </div>
            <div v-if="item.rating_store" class="position-relative">
              <img style="height: 25px" src="../assets/img/star_gold.svg" alt="">
              <p class="m-0 position-absolute font-5 text-white number_star">{{ item.rating_store }}</p>
            </div>
          </div>
          <div style="height: 35px" class="d-flex justify-content-between align-items-center">
            <div class="d-flex">
              <img style="width: 15px" src="../assets/img/list.svg" alt="">
              <p class="m-0 font-5 mx-2">{{ item.brand }}</p>
            </div>

            <div v-if="item.count == 0" class="existence rounded-pill">
              <p class="m-0 font-color font-5 px-2 py-1">
                ناموجود
              </p>
            </div>
          </div>

          <hr>

          <div class="price_div align-items-center d-flex justify-content-between">
            <div class="d-flex">

              <p class="m-0 font-5" :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' ">
                <span class="mx1">{{ item.price.toLocaleString() }}</span>
                <span v-if="item.off_price == null" class="mx1">تومان</span>
              </p>
              &nbsp;
              <p v-if="item.off_price != null" class="m-0 font-5 font-color mb-1">
                <span class="mx1">{{ item.off_price.toLocaleString() }}</span>
                <span class="mx1">تومان</span>
              </p>

            </div>

            <p class="off_percent m-0 font-5 rounded-pill font-color">
              <span>%</span>
              <span>{{ item.discount }}</span>
            </p>
          </div>
        </div>
      </router-link>

    </div>

    <div v-if="page == 'store'" class="list_products p-body">

      <div v-if="store.length == 0"
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
          <br>
          <p class="font-5 ">
            فروشگاه نشان شده ای وجود ندارد
          </p>
        </div>
      </div>

      <!--      ***  فروشگاه   *** -->
      <router-link v-else v-for="item in store" :key="item.id" :to="{name:'StorePage' , params:{unit_id:item.id}}"
           class="products_custom animate__animated animate__fadeIn rounded-4 h-auto text-decoration-none text-black d-flex flex-row-reverse justify-content-between mb-2 shadow-costom p-body">

          <div style="height: 9rem;width: 11rem" class="animated-background rounded-4">
            <img style="object-fit: cover" class="rounded-4 w-100 h-100" :src="item.unit_logo" alt="">
          </div>

        <div style="width: calc(100% - 11.5rem)" class="information_products d-flex flex-column justify-content-between">

          <div style="height: 35px" class="d-flex justify-content-start align-items-center my-2">
            <div class="d-flex">
              <img style="width: 20px" src="../assets/img/shop.svg" alt="">
              <p class="m-0 font-5 mx-2">{{ item.unit_name }}</p>
            </div>
          </div>


          <div class="price_div d-flex justify-content-between">
            <div class="d-flex">
              <p class="m-0 font-5 font-color mb-1">
                <span class="mx1">{{ item.city_name }}</span>
                -
                <span class="mx1">{{ item.state_name }}</span>
              </p>
            </div>
          </div>
        </div>
      </router-link>
    </div>

    <div v-if="page == 'education'" class="list_products p-body">

      <div v-if="eductions.length == 0"
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
          <br>
          <p class="font-5 ">
            آموزش نشان شده ای وجود ندارد
          </p>
        </div>
      </div>

      <!--      ***  اموزش   *** -->

      <router-link v-else v-for="item in eductions" :key="item.id"
           class="animate__animated animate__fadeIn rounded-shaped d-flex flex-row-reverse justify-content-between text-black bg-white text-decoration-none mb-2 p-2 rounded-4 shadow-costom"
           :to="{name:'DetailsEducation' , params:{id:item.id}}">

          <div style="width: 9rem;height: 9rem" class="animated-background rounded-4">
            <img style="object-fit: cover" class="w-100 h-100 rounded-4" :src="item.profile_pic" alt="">
          </div>

        <div style="width: calc(100% - 9rem)" class="d-flex flex-column justify-content-around mr-2">

          <p class="font-5 font-bold text-end ">{{ item.name }}</p>

          <p class="font-5 d-flex justify-content-end">
            <span>{{ item.course_length }}</span>
            &nbsp;
            <span>
           ساعت
         </span>
          </p>
          <hr>
          <div class="price_div d-flex justify-content-between align-items-center">

            <p v-if="item.off_price != null && item.discount != 0 "
               class="off_percent font-6 rounded-pill font-color p-1 m-0">
              <span>{{ item.discount }}</span>
              <span>%</span>
            </p>

            <div class="d-flex justify-content-between">


              <p v-if="item.off_price != null" class="font-5 d-flex font-color m-0 ml-1">
                <span class="">تومان</span>
                <span class="ml-1">{{ parseInt(item.off_price).toLocaleString() }}</span>
              </p>

              <p class="m-0 d-flex ml-1"
                 :class="item.off_price == null ? 'font-color font-5' : 'text-decoration-line-through font-5' ">
                <span v-if="item.off_price == null " class="">تومان</span>
                <span class="ml-1">{{ parseInt(item.price).toLocaleString() }}</span>
              </p>


            </div>

          </div>
        </div>

      </router-link>


    </div>

    <div v-if="page == 'executive'" class="list_products p-body">

      <div v-if="executives.length == 0"
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
          <br>
          <p class="font-5 ">
            مجری نشان شده ای وجود ندارد
          </p>
        </div>
      </div>

      <!--      ***  مجری   *** -->
      <router-link v-else v-for="item in executives" :key="item.id"
           :to="{name:'DetailsExecutives' , params:{prof_id:item.id}}"
           class="animate__animated animate__fadeIn rounded-shaped d-flex text-decoration-none shadow-costom justify-content-between bg-white mb-2 rounded-4 p-2">
        <div style="width: calc(100% - 9rem)" class="d-flex flex-column justify-content-around px-2 py-2">
          <p class="font-5 mb-2 font-bold text-end">{{ item.name }}</p>
          <p class="text_information font-5">{{ item.description }}</p>
          <p class="m-0 font-5 text-end">
            <span>{{ item.state }}</span>
            -
            <span>{{ item.city }}</span>
          </p>
        </div>
        <div class="animated-background rounded-4">
          <img style="height: 9rem;width: 9rem;object-fit: cover" class="rounded-4" :src="item.profile_pic" alt="">
        </div>
      </router-link>

    </div>

    <div v-if="page == 'adver'" class="list_products p-body">

      <div v-if="advers.length == 0"
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
          <br>
          <p class="font-5 ">
            آگهی نشان شده ای وجود ندارد
          </p>
        </div>
      </div>


      <!--      ***  اگهی   *** -->
      <router-link v-else v-for="item in advers" :key="item.id"
           :to="{name:'DetailsAdvertising' , params:{adver_id:item.id}}"
           class="animate__animated animate__fadeIn rounded-shaped d-flex text-decoration-none shadow-costom bg-white mb-2 rounded-4 p-2">
        <div style="width: calc(100% - 9rem)" class="mr-1 d-flex flex-column align-items-end justify-content-between px-2 py-2">
          <p class="font-5 font-bold text-end">{{ item.adver_name }}</p>
          <p class="text_information font-5">{{ item.description }}</p>
          <p class="m-0 font-5 text-end">
            <span>{{ item.state }}</span>
            -
            <span>{{ item.city }}</span>
          </p>
        </div>
        <div class="animated-background rounded-4">
          <img style="height: 9rem;width: 9rem;object-fit: cover" class="rounded-4" :src="item.pic[0]" alt="">
        </div>
      </router-link>

    </div>

  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">

    <NavbarPage></NavbarPage>

    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-4 w-75 ma-auto">نشان شده ها</div>

    <div class="w-75 ma-auto bg-white rounded-4 p-3">

      <div class="list_saver justify-space-evenly mt-2 overflow-x-scroll">

        <v-btn @click="page = 'prod' " :class="page === 'prod' ? 'bg-color' : 'bg-unavailable' "
               class="title_saver p-2 h-100 font-5 rounded-3 border-costom text-white mx-1"
        style="min-width: 13rem">
          محصولات نشان شده
        </v-btn>

        <v-btn @click="page = 'adver' " :class="page === 'adver' ? 'bg-color' : 'bg-unavailable' "
               class="title_saver p-2 h-100 font-5 rounded-3 border-costom text-white mx-1"
               style="min-width: 13rem">
          آگهی نشان شده
        </v-btn>

        <v-btn @click="page = 'executive' " :class="page === 'executive' ? 'bg-color' : 'bg-unavailable' "
               class="title_saver p-2 h-100 font-5 rounded-3 border-costom text-white mx-1"
               style="min-width: 13rem">
          مجری نشان شده
        </v-btn>

        <v-btn @click="page = 'education' " :class="page === 'education' ? 'bg-color' : 'bg-unavailable' "
               class="title_saver p-2 h-100 font-5 rounded-3 border-costom text-white mx-1"
               style="min-width: 13rem">
          آموزش نشان شده
        </v-btn>

        <v-btn @click="page = 'store' " :class="page === 'store' ? 'bg-color' : 'bg-unavailable' "
               class="title_saver p-2 h-100 font-5 rounded-3 border-costom text-white mx-1"
               style="min-width: 13rem">
          فروشگاه نشان شده
        </v-btn>

      </div>

      <br>

      <div v-if="page === 'prod'" class="list_products-web py-2">
        <!--      ***  محصول   *** -->

        <div v-if="products.length === 0"
             class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
            <br>
            <p class="font-5 ">
              محصول نشان شده ای وجود ندارد
            </p>
          </div>
        </div>

        <router-link v-else v-for="item in products" :key="item.id" :to="{name:'DetailsProducts' , params:{prod_id:item.id , sub_cat_id:item.sub_categoris}}"
                     class="products_custom_web animate__animated item animate__fadeIn rounded-shaped text-decoration-none mx-1 text-black d-flex flex-row-reverse justify-content-between mb-3 shadow-costom p-body">

          <div style="width: calc(100% - 10.5rem)" class="information_products d-flex flex-column justify-content-around">

            <p class="m-0 font-5 font-bold ">{{ item.name }}</p>
            <div class="d-flex justify-content-start align-items-center my-1">
              <div class="d-flex">
                <img style="width: 1.2rem" src="../assets/img/shop.svg" alt="">
                <p class="m-0 font-5 mx-2">{{ item.store_name }}</p>
              </div>
              <div v-if="item.rating_store" class="position-relative">
                <img style="width: 1.8rem" src="../assets/img/star_gold.svg" alt="">
                <p class="m-0 position-absolute font-5 text-white number_star">{{ item.rating_store }}</p>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex">
                <img style="width: 1.2rem" src="../assets/img/list.svg" alt="">
                <p class="m-0 font-5 mx-2">{{ item.brand }}</p>
              </div>

              <div v-if="item.count == 0" class="existence rounded-pill">
                <p class="m-0 font-color-red font-bold font-5 px-2 py-1">
                  ناموجود
                </p>
              </div>
            </div>

            <hr>

            <div class="price_div align-items-center d-flex justify-content-between">
              <div class="d-flex">

                <p class="m-0 font-5" :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' ">
                  <span class="">{{ item.price.toLocaleString() }}</span>
                  <span v-if="item.off_price == null" class="mx-1">تومان</span>
                </p>
                &nbsp;
                <p v-if="item.off_price != null" class="m-0 font-5 font-color mb-1">
                  <span class="">{{ item.off_price.toLocaleString() }}</span>
                  <span class="mx-1">تومان</span>
                </p>

              </div>


              <p class="off_percent m-0 font-5 rounded-pill font-color">
                <span>%</span>
                <span>{{ item.discount }}</span>
              </p>
            </div>
          </div>

          <div class="position-relative animated-background rounded-4 div_img_products_web">

            <img v-if="item.pic1 == null " class="img_products rounded-4" src="../assets/img/img-notavalible.jpg"
                 alt="">

            <img v-else class="img_products rounded-4" :src="item.pic1" alt="">

            <div v-if="item.rating_product != null"
                 class="div_stars py-1 px-4 rounded-pill d-flex position-absolute shadow-costom align-items-center">

              <img style="width: 20px" src="../assets/img/star_gold.svg" alt="">

              <p class="font-5 mx-1 text-center">{{ item.rating_product }}</p>
            </div>

          </div>

        </router-link>
      </div>

      <div v-if="page === 'store'" class="list_products-web py-2">

        <div v-if="store.length === 0"
             class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
            <br>
            <p class="font-5 ">
              فروشگاه نشان شده ای وجود ندارد
            </p>
          </div>
        </div>

        <!--      ***  فروشگاه   *** -->
        <router-link v-else v-for="item in store" :key="item.id" :to="{name:'StorePage' , params:{unit_id:item.id}}"
                     class="products_custom_web animate__animated animate__fadeIn mx-1 rounded-4 h-auto text-decoration-none text-black d-flex flex-row-reverse justify-content-between mb-4 shadow-costom p-body">

          <div style="width: calc(100% - 16rem)" class="d-flex flex-column justify-content-between">
            <div style="height: 35px" class="d-flex justify-content-start align-items-center my-2">
              <div class="d-flex">
                <img style="width: 1.2rem" src="../assets/img/shop.svg" alt="">
                <p class="m-0 font-5 mx-2">{{ item.unit_name }}</p>
              </div>
            </div>

            <div class="price_div d-flex justify-content-between">
              <div class="d-flex">
                <p class="m-0 font-5 font-color mb-1">
                  <span class="mx-1">{{ item.state_name }}</span>
                  -
                  <span class="mx-1">{{ item.city_name }}</span>
                </p>
              </div>
            </div>
          </div>

          <div style="height:10rem;width: 15rem" class="animated-background rounded-4">
            <img class="rounded-4 img-cover w-100 h-100" :src="item.unit_logo" alt="">
          </div>

        </router-link>

      </div>

      <div v-if="page === 'education'" class="list_products-web py-2">

        <div v-if="eductions.length == 0"
             class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
            <br>
            <p class="font-5 ">
              آموزش نشان شده ای وجود ندارد
            </p>
          </div>
        </div>

        <!--      ***  اموزش   *** -->

        <router-link v-else v-for="item in eductions" :key="item.id"
                     class="animate__animated animate__fadeIn products_custom_web mx-1 rounded-4 d-flex justify-content-between text-black bg-white text-decoration-none mb-2 p-2 rounded-4 shadow-costom"
                     :to="{name:'DetailsEducation' , params:{id:item.id}}">

          <div style="width: 10rem;height: 10rem" class="animated-background rounded-4">
            <img class="w-100 h-100 rounded-4" :src="item.profile_pic" alt="">
          </div>


          <div style="width: calc(100% - 10rem)" class="mr-2 d-flex flex-column justify-content-around">

            <p class="font-5 font-bold text-end ">{{ item.name }}</p>

            <p class="font-5 d-flex">
              {{ item.course_length }}
            </p>

            <hr>

            <div class="price_div d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-between">
                <p class="m-0 d-flex ml-1"
                   :class="item.off_price == null ? 'font-color font-5' : 'text-decoration-line-through font-5' ">
                  <span class="ml-1">{{ parseInt(item.price).toLocaleString() }}</span>
                  <span v-if="item.off_price == null " class="">تومان</span>
                </p>

                <p v-if="item.off_price != null" class="font-5 d-flex font-color m-0 ml-1">
                  <span class="ml-1">{{ parseInt(item.off_price).toLocaleString() }}</span>
                  <span class="">تومان</span>
                </p>
              </div>

              <p v-if="item.off_price != null && item.discount != 0 "
                 class="off_percent font-5 rounded-pill font-color p-2 m-0">
                <span>{{ item.discount }}</span>
                <span>%</span>
              </p>
            </div>
          </div>

        </router-link>

      </div>

      <div v-if="page === 'executive'" class="list_products-web py-2">

        <div v-if="executives.length == 0"
             class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
            <br>
            <p class="font-5 ">
              مجری نشان شده ای وجود ندارد
            </p>
          </div>
        </div>

        <!--      ***  مجری   *** -->
        <router-link v-else v-for="item in executives" :key="item.id"
                     :to="{name:'DetailsExecutives' , params:{prof_id:item.id}}"
                     class="animate__animated animate__fadeIn products_custom_web mx-1 rounded-shaped d-flex text-decoration-none shadow-costom justify-content-between bg-white mb-2 rounded-4 p-2">
          <div style="width: 10rem;height: 10rem" class="animated-background rounded-4">
            <img class="rounded-4 img-cover w-100 h-100" :src="item.profile_pic" alt="">
          </div>

          <div style="width: calc(100% - 10rem)" class="px-2 py-2 d-flex flex-column justify-content-around">
            <p class="font-5 mb-2 font-bold text-end">{{ item.name }}</p>
            <p class="text_information font-5">{{ item.description }}</p>
            <p class="m-0 font-5 text-end">
              <span>{{ item.state }}</span>
              -
              <span>{{ item.city }}</span>
            </p>
          </div>
        </router-link>

      </div>

      <div v-if="page === 'adver'" class="list_products-web py-2">

        <div v-if="advers.length == 0"
             class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
            <br>
            <p class="font-5 ">
              آگهی نشان شده ای وجود ندارد
            </p>
          </div>
        </div>

        <!--      ***  اگهی   *** -->
        <router-link v-else v-for="item in advers" :key="item.id"
             :to="{name:'DetailsAdvertising' , params:{adver_id:item.id}}"
             class="animate__animated animate__fadeIn mx-1 products_custom_web rounded-shaped d-flex text-decoration-none shadow-costom bg-white mb-2 rounded-4 p-2">
          <div style="width: 10rem;height: 10rem" class="animated-background rounded-4">
            <img class="w-100 h-100 img-cover rounded-4" :src="item.pic[0]" alt="">
          </div>

          <div style="width: calc(100% - 10rem)" class="mr-1 d-flex flex-column justify-content-between px-2 py-2">
            <p class="font-5 font-bold text-end">{{ item.adver_name }}</p>
            <p class="text_information font-5">{{ item.description }}</p>
            <p class="m-0 font-5 text-end">
              <span>{{ item.state }}</span>
              -
              <span>{{ item.city }}</span>
            </p>
          </div>
        </router-link>

      </div>

    </div>
  </div>

</template>

<style scoped>

.list_saver {
  width: 100%;
  overflow-x: scroll;
  height: 5rem;
  display: flex;
  direction: rtl;
  padding: .5rem;
}

.img_executives {
  width: 100%;
  height: 12.5em;
  object-fit: cover;
}

.title_saver {
  min-width: 10em;
  font-size: 1em;
}

.products_custom {
  padding: 10px 7px 10px 7px;
  border-radius: 15px;
  width: 100%;
  background-color: white;
}

.text_information {
  height: 2.5rem;
  position: relative;
  width: 100%;
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
}

.img_products {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}

.div_stars {
  width: 65px;
  height: 30px;
  right: 50%;
  transform: translate(50%, 0);
  bottom: -4px;
  background-color: white;
  justify-content: center;
}

.list_products-web::-webkit-scrollbar{
  display: none;
}

.off_percent {
  padding: 5px;
  text-align: center;
  background-color: #d2d2d2;
}

.number_star {
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.div_img_products {
  width: 50%;
  padding-left: 8px;
}

.information_products {
  direction: rtl;
  width: 50%;
}

.existence {
  border: 1px solid #8C8C8CA0;
  background-color: #d2d2d2;
}

/*'products'*/

.list_products-web {
  max-height: 40rem;
  overflow-y: scroll;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
}

.item {
  height: fit-content;
  flex-basis: 48%;
  flex-grow: 1;
  margin: .5rem 0;
}

.products_custom_web {
  padding: 1rem;
  background-color: white;
  flex-basis: 49%;
  flex-grow: 0;
}

@media (max-width:1285px ) {
  .products_custom_web{
    min-width: 27rem;
    flex-grow: 1;
  }
}

.div_img_products_web {
  width: 10rem;
  height: 10rem;
  object-fit: cover;
}

</style>